
import React from "react";

const PlayButton = () => (
    <svg width="68" height="66" viewBox="0 0 68 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="60" height="60" rx="30" fill="white" fill-opacity="0.5"/>
    <path d="M26.7929 21L48.208 33.3585L26.7929 46L26.7929 21Z" fill="#FF2626"/>
    </svg>
);

export default PlayButton;
